// ── useDebounce (fp-nofodesk-9) — extracted from App.js ──
import { useState, useEffect } from "react";
// ── Debounce hook ─────────────────────────────────────────────
function useDebounce(value, delay) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

export { useDebounce };
